import { render, staticRenderFns } from "./MirrorGame.vue?vue&type=template&id=5168f8fa&scoped=true&"
import script from "./MirrorGame.vue?vue&type=script&lang=js&"
export * from "./MirrorGame.vue?vue&type=script&lang=js&"
import style0 from "./MirrorGame.vue?vue&type=style&index=0&id=5168f8fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168f8fa",
  null
  
)

export default component.exports